import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
    selector: 'bazis-simple-context-menu',
    templateUrl: './simple-context-menu.component.html',
    imports: [CommonModule, TranslocoModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SimpleContextMenuComponent {
    readonly menu = input<
        [
            {
                titleKey: string;
                titleParams?: {
                    [index: string]: any;
                };
                clickFn: () => void;
            },
        ]
    >();
}
